import jsPDF from "jspdf";
import dayjs from "dayjs";
import laiSenBale from "./pic/a2.jpg";
import arabicToThai from "../../../../hook/arabicToThai";
import { drawRichText, b } from "./richText";

export async function exportNotifyGuarantor3NNew(
    dataTabelB,
    selectedContract,
    currentBatchNumber
) {

    const [, , numberToThaiText] = arabicToThai();

    const doc = new jsPDF('p', 'mm', 'a4');

    dataTabelB.forEach((item, index) => {

        if (index > 0) doc.addPage();

        let y = 10; // ตำแหน่ง Y เริ่มต้น

        doc.setFont('THSarabunNew', 'normal');
        doc.setFontSize(14);

        // --- ส่วนหัว (ชื่อลูกค้า / ที่อยู่ สำหรับซองจดหมาย) ---
        const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1}
                                    ต.${item?.TUMB} อ.${item?.AUMPDES} จ.${item?.PROVDES} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.roundDate).format('DD/MM/YYYY')})
        `;
        doc.text(address, 5, y);
        doc.text(`${index + 1}/${currentBatchNumber}`, 180, y);
        y += 77;

        // --- วันที่ ---
        const dataNow = dayjs(item.roundDate).format('DD/MM/YYYY'); // วันที่ยึด
        doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
        y += 10;

        // --- เรื่อง / เรียน ---
        const s1 = `
        เรื่อง บอกกล่าวให้ชำระหนี้
        `;
        // const s1 = `
        // เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        // `;
        doc.text(s1, 5, y);
        y += 7;

        const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2}
        `;
        doc.text(s2, 5, y);
        y += 22;

        // --- ค่าเงินและคำอ่าน ---
        const tcarcst = Number(item?.TCARCST ?? 0).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const tcarcstThaiText = numberToThaiText(tcarcst);

        const amount = Number((item?.TOT_UPAY ?? 0) * (item?.EXP_PRD ?? 0)).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const amountThaiText = numberToThaiText(amount);

        // --- เนื้อหา (ตัวหนาเฉพาะค่าที่ต้องเน้น ผ่าน b() ที่เหลือเป็นตัวปกติ) ---
        const indent = "          "; // ย่อหน้าแรก
        const bodyX = 15;
        const bodyWidth = 175;
        const lineHeight = 7;

        const p1 = [
            `${indent}ตามที่ท่านผู้กู้ได้ตกลงทำสัญญากู้ยืมเงินจำนวน `,
            b(`${tcarcst} บาท (${tcarcstThaiText})`),
            ` ไปจากบริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่) ตามสัญญากู้ยืมเงิน ลงวันที่ `,
            b(dayjs(item.SDATE).format('DD/MM/YYYY')),
            ` โดยผู้กู้ได้รับเงินไปครบถ้วนแล้วและได้สมุคคู่มือจดทะเบียนรถยนต์ ยี่ห้อ `,
            b(item.TYPE),
            ` เลขตัวถัง `,
            b(item.STRNO),
            ` เลขเครื่อง `,
            b(item.ENGNO),
            ` ทะเบียน `,
            b(`${item.REGNO} ${item.DORECV}`),
            ` สี `,
            b(item.COLOR),
            ` มามอบให้ผู้ให้กู้ เพื่อยึดถือไว้เป็นประกันหนี้ตามสัญญากูยืมเงิน และท่านได้ทำสัญญาค้ำประกันหนี้ดังกล่าว รายละเอียดท่านทราบแจ้งชัดดีอยู่แล้วนั้น`,
        ];

        const p2 = [
            `${indent}บัดนี้ ผู้กู้ได้ผิดนัดและค้างชำระหนี้ค่างวดที่ ${item.EXP_FRM} - ${item.EXP_TO} ซึ่งกำหนดชำระ `,
            b(dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')),
            ` จำนวน ${item.EXP_PRD} งวดติดต่อกันเป็นจำนวนเงิน `,
            b(`${amount} บาท (${amountThaiText})`),
            ` ผู้ให้กู้จึงแจ้งมายังท่านเพื่อให้ชำระหนี้ที่ผู้กู้ค้างชำระ พร้อมดอกเบี้ย เบี้ยปรับ และค่าใช้จ่ายทั้งหมดให้แล้วเสร็จภายใน 7 วัน นับตังแต่วันที่ท่านได้รับหนังสือฉบับนี้`,
        ];

        const p3 = [
            `${indent}หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้กู้มีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`,
        ];

        y = drawRichText(doc, bodyX, y, bodyWidth, lineHeight, p1);
        y += lineHeight;
        y = drawRichText(doc, bodyX, y, bodyWidth, lineHeight, p2);
        y += lineHeight;
        y = drawRichText(doc, bodyX, y, bodyWidth, lineHeight, p3);

        y += lineHeight * 2;
        doc.text('จึงเรียนมาเพื่อโปรดดำเนินการด่วน', 30, y);

        // --- ส่วนลงนาม ---
        y += 20;
        const signatureImg = laiSenBale;
        doc.addImage(signatureImg, 'PNG', 155, y - 11, 30, 15);
        doc.text('ลงชื่อ....................................', 150, y);
        y += 7;
        doc.text('ผู้ออกจดหมาย', 159, y);

        y += 24;
        doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
    });

    doc.autoPrint();
    return doc.output("bloburl");

}
